// Perfil do usuário logado: administrador da plataforma (tela Administração).
// A lista fica em config/plataforma.administradores (e-mails). Sem esse documento vale a
// regra antiga (empresa com ID fixo), para ninguém perder o acesso ao publicar esta versão.
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { auth, firestore } from '../../config/firebaseConfig';

const EMPRESA_ADMIN_LEGADA = 'aGL5hULwC15AwkR9AdF4';
const regraLegada = () => localStorage.getItem('tenantId') === EMPRESA_ADMIN_LEGADA;

// null enquanto verifica; depois true/false
export function useEhAdministrador() {
  const [ehAdmin, setEhAdmin] = useState(null);

  useEffect(() => {
    let ativo = true;
    const email = String(auth.currentUser?.email || '').toLowerCase();
    getDoc(doc(firestore, 'config', 'plataforma'))
      .then((d) => {
        const lista = d.exists() && Array.isArray(d.data().administradores)
          ? d.data().administradores.map((e) => String(e).toLowerCase())
          : null;
        if (ativo) setEhAdmin(lista ? lista.includes(email) : regraLegada());
      })
      .catch(() => { if (ativo) setEhAdmin(regraLegada()); });
    return () => { ativo = false; };
  }, []);

  return ehAdmin;
}
